import type { GroupApiResponse } from '../../features/groups/groups.models';

/**
 * グループMockデータ
 * APIレスポンス形式（/api/v0/groups が返す形式）
 *
 * 階層構造:
 * - 年度ノード（2025年度/2024年度）は projectId を持たず、配下に葉ノード（契約区分ごと）を持つ
 * - 葉ノード（契約区分）が projectId を持ち、グループツリー表示からは除外される
 * - 年度ノードを選択すると、右側に配下の葉ノードに紐づく project 一覧が表示される
 *
 * テナント分離:
 * - tenant-mock-001 (GX)     → GX ツリー (group-001 配下)
 * - tenant-mock-002 (GX事務局) → GX事務局 ツリー (group-010 配下)
 */

// === GX テナント（tenant-mock-001）のグループ ===
const GX_TENANT_GROUPS: GroupApiResponse[] = [
  // ルート
  {
    publicId: 'group-001',
    name: 'GX',
    parentId: null,
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // 第2階層（GX配下）
  {
    publicId: 'group-002',
    name: '八幡・周南',
    parentId: 'group-001',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-003',
    name: '東日本製鉄所',
    parentId: 'group-001',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-01-14T09:30:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // 第3階層（八幡・周南配下）
  {
    publicId: 'group-004',
    name: '日本製鐵',
    parentId: 'group-002',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // 第4階層（日本製鐵配下）
  {
    publicId: 'group-005',
    name: '八幡事業所',
    parentId: 'group-004',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // 第5階層（八幡事業所配下）- 年度ノード（project 直接紐付けなし、配下に葉ノードを持つ）
  {
    publicId: 'group-006',
    name: '2025年度',
    parentId: 'group-005',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-007',
    name: '2024年度',
    parentId: 'group-005',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-01-10T14:00:00.000Z',
    createdAt: '2024-01-01T00:00:00.000Z',
  },

  // 第6階層（2025年度配下）- 葉ノード（project 紐付けあり、ツリー非表示）
  {
    publicId: 'group-020',
    name: '直接雇用・正社員',
    parentId: 'group-006',
    projectId: 'project-001',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-021',
    name: '直接雇用・契約社員（有期）',
    parentId: 'group-006',
    projectId: 'project-002',
    description: '',
    displayOrder: 2,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-022',
    name: '直接雇用・アルバイト',
    parentId: 'group-006',
    projectId: 'project-003',
    description: '',
    displayOrder: 3,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-023',
    name: '間接雇用・出向者',
    parentId: 'group-006',
    projectId: 'project-004',
    description: '',
    displayOrder: 4,
    updatedAt: '2025-01-15T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // 第6階層（2024年度配下）- 葉ノード
  {
    publicId: 'group-024',
    name: '直接雇用・正社員',
    parentId: 'group-007',
    projectId: 'project-005',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-10T14:00:00.000Z',
    createdAt: '2024-01-01T00:00:00.000Z',
  },

  // === 東日本製鉄所配下 ===
  {
    publicId: 'group-008',
    name: '君津事業所',
    parentId: 'group-003',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-14T09:30:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-009',
    name: '2025年度',
    parentId: 'group-008',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-14T09:30:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-025',
    name: '直接雇用・契約社員（無期）',
    parentId: 'group-009',
    projectId: 'project-006',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-14T09:30:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // === 中部製鉄所配下（cursor pagination 検証用に件数を増やすため追加） ===
  {
    publicId: 'group-029',
    name: '中部製鉄所',
    parentId: 'group-001',
    projectId: null,
    description: '',
    displayOrder: 3,
    updatedAt: '2025-01-13T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-030',
    name: '名古屋事業所',
    parentId: 'group-029',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-13T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-031',
    name: '2025年度',
    parentId: 'group-030',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-13T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-032',
    name: '直接雇用・正社員',
    parentId: 'group-031',
    projectId: 'project-010',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-13T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },

  // === 西日本製鉄所配下（cursor pagination 検証用に件数を増やすため追加） ===
  {
    publicId: 'group-033',
    name: '西日本製鉄所',
    parentId: 'group-001',
    projectId: null,
    description: '',
    displayOrder: 4,
    updatedAt: '2025-01-12T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-034',
    name: '大阪事業所',
    parentId: 'group-033',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-12T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-035',
    name: '神戸事業所',
    parentId: 'group-033',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-01-12T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-036',
    name: '2025年度',
    parentId: 'group-034',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-12T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
  {
    publicId: 'group-037',
    name: '直接雇用・契約社員（有期）',
    parentId: 'group-036',
    projectId: 'project-011',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-01-12T10:00:00.000Z',
    createdAt: '2025-01-01T00:00:00.000Z',
  },
];

// === GX事務局 テナント（tenant-mock-002）のグループ ===
const GX_JIMUKYOKU_TENANT_GROUPS: GroupApiResponse[] = [
  // ルートレベル
  {
    publicId: 'group-010',
    name: 'GX事務局',
    parentId: null,
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },

  // 第2階層（GX事務局配下）
  {
    publicId: 'group-011',
    name: 'A社',
    parentId: 'group-010',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },
  {
    publicId: 'group-012',
    name: 'B社',
    parentId: 'group-010',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },
  {
    publicId: 'group-013',
    name: 'C社',
    parentId: 'group-010',
    projectId: null,
    description: '',
    displayOrder: 3,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },

  // 第3階層（A社配下）- 年度ノード
  {
    publicId: 'group-014',
    name: '2025年度',
    parentId: 'group-011',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },
  {
    publicId: 'group-015',
    name: '2024年度',
    parentId: 'group-011',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2024-02-01T00:00:00.000Z',
  },

  // 第4階層（A社 2025年度配下）- 葉ノード
  {
    publicId: 'group-026',
    name: '直接雇用・正社員',
    parentId: 'group-014',
    projectId: 'project-007',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },

  // 第4階層（A社 2024年度配下）- 葉ノード
  {
    publicId: 'group-027',
    name: '直接雇用・契約社員（有期）',
    parentId: 'group-015',
    projectId: 'project-008',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2024-02-01T00:00:00.000Z',
  },

  // 第3階層（B社配下）- 年度ノード
  {
    publicId: 'group-016',
    name: '2025年度',
    parentId: 'group-012',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },
  {
    publicId: 'group-017',
    name: '2024年度',
    parentId: 'group-012',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2024-02-01T00:00:00.000Z',
  },

  // 第4階層（B社 2025年度配下）- 葉ノード
  {
    publicId: 'group-028',
    name: '直接雇用・アルバイト',
    parentId: 'group-016',
    projectId: 'project-009',
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },

  // 第3階層（C社配下）- 年度ノード（2024年度は project 未登録のため葉ノードなし）
  {
    publicId: 'group-018',
    name: '2025年度',
    parentId: 'group-013',
    projectId: null,
    description: '',
    displayOrder: 1,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2025-02-01T00:00:00.000Z',
  },
  {
    publicId: 'group-019',
    name: '2024年度',
    parentId: 'group-013',
    projectId: null,
    description: '',
    displayOrder: 2,
    updatedAt: '2025-02-01T10:00:00.000Z',
    createdAt: '2024-02-01T00:00:00.000Z',
  },

  // 第4階層（C社 2025年度配下）- 葉ノード
  // Issue #550: 総括表の変換失敗（conversion_error）バナーを画面確認するための導線。
  // 失敗理由ごとの projects は 007（利用上限）/ 008（AI エラー）/ 009（理由不明）と
  // ここ（015 = 変換エラー）に分けて配置している
  {
    publicId: 'group-038',
    name: '直接雇用・正社員',
    parentId: 'group-018',
    projectId: 'project-015',
    description: '',
    displayOrder: 1,
    updatedAt: '2026-09-01T02:05:00.000Z',
    createdAt: '2026-09-01T00:00:00.000Z',
  },
];

/**
 * テナントID → 配下のグループ一覧
 */
const MOCK_GROUPS_BY_TENANT: Record<string, GroupApiResponse[]> = {
  'tenant-mock-001': GX_TENANT_GROUPS,
  'tenant-mock-002': GX_JIMUKYOKU_TENANT_GROUPS,
};

/**
 * 指定テナントに属するグループ一覧を取得
 * テナントに対応するデータが無い場合は空配列を返す
 */
export function getGroupsByTenantId(tenantId: string): GroupApiResponse[] {
  return MOCK_GROUPS_BY_TENANT[tenantId] ?? [];
}

/**
 * 指定テナント配下から グループ ID でグループを取得
 */
export function findGroupById(
  id: string,
  tenantId: string,
): GroupApiResponse | undefined {
  return getGroupsByTenantId(tenantId).find((g) => g.publicId === id);
}
